var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tecnicos"},[(_vm.datos)?_c('datos-form',{attrs:{"datosProp":_vm.datos}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }